"use client";

import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
}

const StyledSkeleton = styled.div<{
  $width?: string | number;
  $height?: string | number;
  $borderRadius?: string | number;
}>`
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: ${({ $borderRadius }) =>
    typeof $borderRadius === "number" ? `${$borderRadius}px` : $borderRadius || "6px"};
  background-color: var(--color-bg-skeleton);
  ${({ $width }) =>
    $width &&
    `width: ${typeof $width === "number" ? `${$width}px` : $width};`}
  ${({ $height }) =>
    $height &&
    `height: ${typeof $height === "number" ? `${$height}px` : $height};`}
`;

function Skeleton({ width, height, borderRadius, ...props }: SkeletonProps) {
  return (
    <StyledSkeleton
      $width={width}
      $height={height}
      $borderRadius={borderRadius}
      {...props}
    />
  );
}

export { Skeleton };
